import React, { useState, useEffect } from "react";
import GlobalStudentActivityList from "../../../pages/common/globalstudentactivitylist"
import GlobalStudentActivityReportList from '../../../pages/common/globalstudentactivityreportlist';
import PageNotes from "../../../pages/common/pagenotesnew";
import { useAuth } from "../../../../usercontext";
import { Tab, Nav } from 'react-bootstrap';

export default function Activities({ slug, show }) {
  const { profile, setProfile } = useAuth();
    const [activeTab, setActiveTab] = useState('studentActivities');
 // console.log("slug: ", slug, "Id: ", profile.id)
  return (
    <>
      <PageNotes
        type={"Instructor"}
        pageName={"Activities"}
        studentId={slug}
        instructorId={profile.id}
      />
      <div>
            <Tab.Container
              defaultActiveKey='programdetails'
              activeKey={activeTab}
              onSelect={(k) => setActiveTab(k)}
            >
              <Nav variant='tabs'>
                <Nav.Item>
                  <Nav.Link eventKey='studentActivities'>Student Activities</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey='studentActivityReports'> Student Activity Reports</Nav.Link>
                </Nav.Item>
              </Nav>
              <Tab.Content>
                <Tab.Pane eventKey='studentActivities'>
                <GlobalStudentActivityList slug={slug} isStudent={false} show={show} />
                </Tab.Pane>
                <Tab.Pane eventKey='studentActivityReports'>
                  <GlobalStudentActivityReportList studentId={slug} />
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </div>
     
    </>
  );
}
